import { Button, MenuItem } from "@mui/material";
import { Select } from "@mui/material";
import { Grid, Paper } from "@mui/material";
import React, { Suspense, useContext, useEffect, useMemo } from "react";
import {
	AuthContext,
	DependentsContext,
	EligibleDependentContext,
	EnrollmentContext,
	GroupOwnerContext,
	PaycheckContext,
	ThemeContext
} from "../../../../../../../contexts";
import { LazyCustomFormDialog, LazyPlanActions, VEBDisclaimer } from "../../../../../../shared";
import { Checkbox } from "@mui/material";
import { useState } from "react";
import { useCallback } from "react";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, { AccordionSummaryProps } from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

import "./familyProtectionForm.css";
import PlanHeader from "../../../../../../shared/enrollment/planCode/PlanHeader";
import { CustomInput, CustomSelectInput } from "../../../../../../shared/CustomInput";
import VEBPlanCard from "../../../../../../shared/VEBPlanCard/VEBPlanCard";
import { VEBPlanFormProps } from "../../../../../../../types/components/enrollmentProps.types";
import CustomEnrollmentDisclaimerDialog from "../../../../../../shared/dialogs/customEnrollmentDisclaimerDialog/customEnrollmentDisclaimerDialog";
import { CustomDisclaimerDialogPropsType } from "../../../../../../../types/dialogProps.types";
import { CustomFormDialogType } from "../../../../../../../types/components/dialogProps.types";
import {
	generateCancerKemperWaiveEnrollmentPayload,
	generateWholeLifeActivateVEBEnrollmentPayload
} from "../../../../../../../utils/commonFunctions/VEBEnrollment/enrollment";
import { VEB_PLAN_NAME, VEB_PLAN_NAMES } from "../../../../../../../constants/plan";
import { VEBEnrollmentPayload } from "../../../../../../../utils/api/enrollment/enrollment";
import {
	AnswerData,
	FiveStarAge,
	FiveStarFaceAmountFrequency,
	FiveStarInsuranceQuestions,
	FiveStarStandardPremiumAmount,
	FiveStarPlanDetails,
	PaycheckFrequency,
	VEBPlan
} from "../../../../../../../types/plan.types";
import { api } from "../../../../../../../utils/api";
import { dateTimeZoneConverter, getFirstOfNextMonth } from "../../../../../../../utils/commonFunctions/date";
import { fiveStarInsurancePlanQuestions } from "./fiveStaePlanData";
import fiveStarInsurancePlanData from "./fiveStarPlanData.json";
import { getFiveStarEligibleDependents } from "../../../../../../../utils/commonFunctions/VEBEnrollment/eligibleDependents";
import { Member } from "../../../../../../../types/employee.types";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Dependent } from "../../../../..";
import { useHistory, useLocation } from "react-router-dom";
import { CoverageCode, VEBWholeLifeEnrollments } from "../../../../../../../types/enrollment.types";
import { Paycheck } from "../../../../../../../types/paycheck.types";
import { VEBOpenEnrollment } from "../../../../../../../types/openEnrollment.types";
import { AddBeneficiary, Beneficiary } from "../../../../../../../types/addBeneficiary.types";
import VEBModal from "../../../../../../shared/VEBModal/VEBModal";
import { trackPromise } from "react-promise-tracker";
import VEBPlanHeader from "../../../../../../shared/enrollment/VEBPlanHeader/PlanHeader";
import EligiblityDialog from "../../../../eligiblityDialogs/EligiblityDialog";
import { EligiblityDialogProps } from "../../../../../../../types/components/eligiblityDialogProps.types";
import calculateAge, { getAgeInDays } from "../../../../../../../utils/commonFunctions/age";
import { BV2Beneficiery } from "../../../../../../../types/BV2Beneficiery.types";
import VEBBeneficiary from "../../../../VEBBeneficiary/VEBBeneficiary";
import { VEBPlanCodes2024 } from "../../../../../../../constants/VEBPlanCodes/VEBPlanCodes2024";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../../../../../constants/VEBYearlyOpenAndCurrentDate";

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
	({ theme }) => ({
		border: `1px solid ${theme.palette.divider}`,
		"&:not(:last-child)": {
			borderBottom: 0
		},
		"&:before": {
			display: "none"
		}
	})
);

const AccordionSummary = styled((props: AccordionSummaryProps) => (
	<MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />} {...props} />
))(({ theme }) => ({
	backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "rgba(0, 0, 0, .03)",
	flexDirection: "row-reverse",
	"& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
		transform: "rotate(90deg)"
	},
	"& .MuiAccordionSummary-content": {
		marginLeft: theme.spacing(1)
	}
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderTop: "1px solid rgba(0, 0, 0, .125)"
}));
const MAX_BENEFIT_THRESHOLD = 50000;
const FiveStarFamilyProtectionForm = ({
	VEBOpenEnrollment,
	getVEBEnrollmentInitData
}: VEBPlanFormProps): JSX.Element => {
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);
	const [writingNumber, setWritingNumber] = useState(1408);
	const [emailDisclaimer, setEmailDisclaimer] = useState("");
	const [waiveReason, setWaiveReason] = useState("");
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const [planCode, setPlanCode] = useState<string>();
	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();
	const [familyProtectionPlan, setFamilyProtectionPlan] = useState<VEBPlan>({
		_id: "",
		plan_name: "",
		plan_code: "",
		start_date: null,
		end_date: null,
		status: ""
	});
	const [fiveStarPlan, setFiveStarPlan] = useState<FiveStarPlanDetails>(fiveStarInsurancePlanData);
	const [answerList, setAnswerList] = useState<AnswerData[]>([]);
	const [allAnswerRecord, setAllAnswerRecord] = useState<string[]>([]);
	const { member } = useContext(AuthContext);
	const { dependents } = useContext(DependentsContext);
	const { paycheck } = useContext(PaycheckContext);
	const { setEligiblity } = useContext(EligibleDependentContext);
	const location = useLocation();
	const history = useHistory();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const [spouse, setSpouse] = useState<Member | undefined>(
		dependents.find((dependent: Member, index: number) => dependent.relationship === "SPOUSE")
	);
	const [children, setChildren] = useState<Member[]>([]);
	const [employeeBenefitAmount, setEmployeeBenefitAmount] = useState<number>(0);
	const [spouseBenefitAmount, setSpouseBenefitAmount] = useState<number>(0);
	const [childBenefitAmount, setChildBenefitAmount] = useState<number>(0);
	const [employeeStandardPremiumAmount, setEmployeeStandardPremiumAmount] = useState<number>(0);
	const [spouseStandardPremiumAmount, setSpouseStandardPremiumAmount] = useState<number>(0);
	const [childStandardPremiumAmount, setChildStandardPremiumAmount] = useState<number>(0);
	const [totalPremiumAmount, setTotalPremiumAmount] = useState<number>(0);
	const [eligibleMembers, setEligibleMembers] = useState<Member[]>([]);
	const [prevWritingNumber] = useState(1408);
	const [showWritingNumberValidateButton, setShowWritingNumberValidateButton] = useState(false);
	const { theme } = useContext(ThemeContext);
	const [coverage_for, setCoverageFor] = useState(""); //Employee Only, Employee & Spouse, Employee & Children,
	const [plan_type, setPlanType] = useState("");
	const [expanded, setExpanded] = useState<string | false>(false);
	const [maxBenefitMember, setMaxBenefitMember] = useState<Member[]>([]);
	const [isActivelyWorking, setIsActivelyWorking] = useState(false);
	const [hasReadTC, setHasReadTC] = useState(false);
	const { groupOwner } = useContext(GroupOwnerContext);
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		VEBPlanName: "Family Protection"
	});
	const [expanded_panel, setExpandedPanel] = useState<string | false>("panel_beneficiary");
	const [addMemberPrimaryBeneficiary, setAddMemberPrimaryBeneficiary] = useState<AddBeneficiary>([
		{
			first_name: spouse?.first_name === undefined ? "" : spouse.first_name,
			last_name: spouse?.last_name === undefined ? "" : spouse.last_name,
			type: "PRIMARY",
			enrollment_id: spouse?._id === undefined ? "" : spouse._id,
			insured_SSN: spouse?.SSN === undefined ? "" : spouse.SSN,
			relation: "SPOUSE",
			SSN: spouse?.SSN === undefined ? "" : spouse.SSN,
			date_of_birth: spouse?.date_of_birth === undefined ? new Date() : new Date(spouse.date_of_birth),
			percentage: 0,
			canEdit: true
		}
	]);
	const [addSpousePrimaryBeneficiary, setAddSpousePrimaryBeneficiary] = useState<AddBeneficiary>([
		{
			first_name: member?.first_name === undefined ? "" : member.first_name,
			last_name: member?.last_name === undefined ? "" : member.last_name,
			type: "PRIMARY",
			enrollment_id: member?._id === undefined ? "" : member._id,
			insured_SSN: member?.SSN === undefined ? "" : member.SSN,
			relation: "SPOUSE",
			SSN: member?.SSN === undefined ? "" : member.SSN,
			date_of_birth: member?.date_of_birth === undefined ? new Date() : new Date(member.date_of_birth),
			percentage: 0,
			canEdit: true
		}
	]);
	const [addMemberContigentBeneficiary, setAddMemberContigentBeneficiary] = useState<AddBeneficiary>([]);
	const [addSpouseContigentBeneficiary, setAddSpouseContigentBeneficiary] = useState<AddBeneficiary>([]);
	const [primaryMemberBeneficiary, setPrimaryMemberBeneficiary] = useState({
		percentage: 0,
		count: 1
	});
	const [contingentMemberBeneficiary, setContingentMemberBeneficiary] = useState({
		percentage: 0,
		count: 0
	});
	const [primarySpouseBeneficiary, setPrimarySpouseBeneficiary] = useState({
		percentage: 0,
		count: 1
	});
	const [contingentSpouseBeneficiary, setContingentSpouseBeneficiary] = useState({
		percentage: 0,
		count: 0
	});
	const [selectCard, setSelectCard] = useState<string>("");
	const [modalOpen, setModalOpen] = useState(false);
	const [editData, setEditData] = useState<null | Beneficiary>(null);
	//BV2 State
	const [BV2employeePrimaryBeneficiary, setBV2EmployeePrimaryBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2employeeContingentBeneficiary, setBV2EmployeeContingentBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2spousePrimaryBeneficiary, setBV2SpousePrimaryBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2spouseContingentBeneficiary, setBV2SpouseContingentBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2childPrimaryBeneficiary, setBV2ChildPrimaryBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2childContingentBeneficiary, setBV2ChildContingentBeneficiary] = useState<BV2Beneficiery[]>([]);

	const getVEBPlanCode = useCallback((VEBOpenEnrollment: any[]) => {
		// console.log("**********VEBOpenEnrollment********", VEBOpenEnrollment[0]);
		let _planCode, _VEBOpenEnrollmentId;
		for (let idx = 0; idx < VEBOpenEnrollment.length; idx++) {
			const planName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
			const planCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
			const VEBPlanId = VEBOpenEnrollment[idx].open_enrollment.veb_plan_id;
			const VEBOpenEnrollmentId = VEBOpenEnrollment[idx].VEB_open_enrollment_id;
			// console.log("<====Plan Name===>", planName);

			if (planName === VEB_PLAN_NAMES.family_protection) {
				_planCode = planCode;
				_VEBOpenEnrollmentId = VEBOpenEnrollmentId;

				const _planPaylaod = {
					_id: VEBPlanId,
					plan_name: planName,
					plan_code: _planCode,
					start_date: null,
					end_date: null,
					status: "ACTIVE"
				};

				setFamilyProtectionPlan(Object.assign({}, _planPaylaod));
			}
		}

		setPlanCode(_planCode);
		setVEBOpenEnrollmentId(_VEBOpenEnrollmentId);
	}, []);

	const validateBeneficiary = useCallback((beneficiary: BV2Beneficiery[], type: "PRIMARY" | "CONTINGENT") => {
		let sum = 0,
			i;
		for (i = 0; i < beneficiary.length; i++) {
			const { percentage } = beneficiary[i];
			sum += percentage;
		}
		return sum;
	}, []);

	const handleBeneficiaryValidate = useCallback(() => {
		let isValid = true;
		if (
			coverage_for === "Employee Only" ||
			coverage_for === "Employee & Spouse" ||
			coverage_for === "Employee & Children" ||
			coverage_for === "Employee & Family"
		) {
			// Primary Beneficiary
			if (BV2employeePrimaryBeneficiary.length === 0) {
				alert("Employee must have alteast One Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			if (BV2employeePrimaryBeneficiary.length > 4) {
				alert("Employee can have atmost Four Primary Beneficiaries!");
				isValid = false;
				return isValid;
			}
			const employeePrimaryPercentageSum = validateBeneficiary(BV2employeePrimaryBeneficiary, "PRIMARY");
			if (employeePrimaryPercentageSum !== 100 && employeePrimaryPercentageSum !== 0) {
				alert("Primary Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}

			// Contingent Beneficiary
			if (BV2employeeContingentBeneficiary.length !== 0) {
				if (BV2employeeContingentBeneficiary.length !== 1) {
					alert("Employee can have only One Contingent Beneficiary!");
					isValid = false;
					return isValid;
				}
			}

			const employeeContingentPercentageSum = validateBeneficiary(BV2employeeContingentBeneficiary, "CONTINGENT");
			if (employeeContingentPercentageSum !== 100 && employeeContingentPercentageSum !== 0) {
				alert("Contingent Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}
		}
		if (
			coverage_for === "Spouse Only" ||
			coverage_for === "Employee & Spouse" ||
			coverage_for === "Spouse & Children" ||
			coverage_for === "Employee & Family"
		) {
			// Primary Beneficiary
			if (BV2spousePrimaryBeneficiary.length === 0) {
				alert("Spouse must have alteast one Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			if (BV2spousePrimaryBeneficiary.length !== 1) {
				alert("Spouse can have only One Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			const spousePrimaryPercentageSum = validateBeneficiary(BV2spousePrimaryBeneficiary, "PRIMARY");
			if (spousePrimaryPercentageSum !== 100 && spousePrimaryPercentageSum !== 0) {
				alert("Spouse Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}

			// Contingent Beneficiary
			if (BV2spouseContingentBeneficiary.length !== 0) {
				if (BV2spouseContingentBeneficiary.length !== 1) {
					alert("Spouse can have only One Contingent Beneficiary!");
					isValid = false;
					return isValid;
				}
			}

			const contingentPercentageSum = validateBeneficiary(BV2spouseContingentBeneficiary, "CONTINGENT");
			if (contingentPercentageSum !== 100 && contingentPercentageSum !== 0) {
				alert("Contingent Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}
		}
		if (
			coverage_for === "Employee & Children" ||
			coverage_for === "Spouse & Children" ||
			coverage_for === "Employee & Family"
		) {
			// Primary Beneficiary
			if (BV2childPrimaryBeneficiary.length === 0) {
				alert("Child can have only One Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			if (BV2childPrimaryBeneficiary.length !== 1) {
				alert("Child can have only One Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			const childPrimaryPercentageSum = validateBeneficiary(BV2childPrimaryBeneficiary, "PRIMARY");
			if (childPrimaryPercentageSum !== 100 && childPrimaryPercentageSum !== 0) {
				alert("Child Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}
			// Contingent Beneficiary
			if (BV2childContingentBeneficiary.length !== 0) {
				if (BV2childContingentBeneficiary.length !== 1) {
					alert("Child can have only One Contingent Beneficiary!");
					isValid = false;
					return isValid;
				}
			}
			const childContingentPercentageSum = validateBeneficiary(BV2childContingentBeneficiary, "CONTINGENT");
			if (childContingentPercentageSum !== 100 && childContingentPercentageSum !== 0) {
				alert("Contingent Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}
		}
	}, [
		BV2childContingentBeneficiary,
		BV2childPrimaryBeneficiary,
		BV2employeeContingentBeneficiary,
		BV2employeePrimaryBeneficiary,
		BV2spouseContingentBeneficiary,
		BV2spousePrimaryBeneficiary,
		coverage_for,
		validateBeneficiary
	]);

	//End BV2 State

	const handleAddBeneficiaryDetails = useCallback(
		(eventName: string, beneficiaryAllDetails: any) => {
			if (eventName === "member-card-add-beneficiary") {
				setSelectCard("member-card");
				setModalOpen(true);
			} else if (eventName === "spouse-card-add-beneficiary") {
				setSelectCard("spouse-card");
				setModalOpen(true);
			} else if (eventName === "save-beneficiary") {
				if (selectCard === "member-card") {
					if ([...addMemberPrimaryBeneficiary, ...addMemberContigentBeneficiary].length > 3) {
						alert("Max 4 beneficiary can be added");
						setModalOpen(false);
						return 0;
					}
					if (
						(primaryMemberBeneficiary.percentage +
							contingentMemberBeneficiary.percentage +
							parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
							200 &&
							(beneficiaryAllDetails.type === "PRIMARY"
								? primaryMemberBeneficiary.percentage +
										parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
								  100
								: contingentMemberBeneficiary.percentage +
										parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
								  100)) ||
						editData !== null
					) {
						if (editData !== null) {
							const editedMemberPrimaryBeneficiary = addMemberPrimaryBeneficiary.map(
								(memberPrimary: Beneficiary, index: number) => {
									if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
										return {
											first_name: beneficiaryAllDetails?.firstName,
											last_name: beneficiaryAllDetails?.lastName,
											type: beneficiaryAllDetails.type,
											enrollment_id: beneficiaryAllDetails?._id,
											insured_SSN: beneficiaryAllDetails?.ssn,
											relation: beneficiaryAllDetails?.relationship,
											address_line_1: beneficiaryAllDetails?.address,
											address_line_2: beneficiaryAllDetails?.address2,
											state: beneficiaryAllDetails?.state,
											ZIP: beneficiaryAllDetails?.zipCode,
											SSN: beneficiaryAllDetails?.ssn,
											date_of_birth:
												beneficiaryAllDetails.dob !== ""
													? new Date(beneficiaryAllDetails.date_of_birth)
													: new Date(),
											gender: beneficiaryAllDetails?.gender,
											percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
											phone_number: beneficiaryAllDetails.telephone,
											canEdit: true
										};
									} else {
										return memberPrimary;
									}
								}
							);
							setAddMemberPrimaryBeneficiary(editedMemberPrimaryBeneficiary);
							const editedMemberContingentBeneficiary = addMemberContigentBeneficiary.map(
								(memberPrimary: Beneficiary, index: number) => {
									if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
										return {
											first_name: beneficiaryAllDetails?.firstName,
											last_name: beneficiaryAllDetails?.lastName,
											type: beneficiaryAllDetails.type,
											enrollment_id: beneficiaryAllDetails?._id,
											insured_SSN: beneficiaryAllDetails?.ssn,
											relation: beneficiaryAllDetails?.relationship,
											address_line_1: beneficiaryAllDetails?.address,
											address_line_2: beneficiaryAllDetails?.address2,
											state: beneficiaryAllDetails?.state,
											ZIP: beneficiaryAllDetails?.zipCode,
											SSN: beneficiaryAllDetails?.ssn,
											date_of_birth:
												beneficiaryAllDetails.dob !== ""
													? new Date(beneficiaryAllDetails.date_of_birth)
													: new Date(),
											gender: beneficiaryAllDetails?.gender,
											percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
											phone_number: beneficiaryAllDetails.telephone,
											canEdit: true
										};
									} else {
										return memberPrimary;
									}
								}
							);
							setAddMemberContigentBeneficiary(editedMemberContingentBeneficiary);
							setEditData(null);
						} else {
							if (beneficiaryAllDetails.type === "PRIMARY") {
								const newBeneficiary: Beneficiary = {
									first_name: beneficiaryAllDetails?.firstName,
									last_name: beneficiaryAllDetails?.lastName,
									type: beneficiaryAllDetails.type,
									enrollment_id: beneficiaryAllDetails?._id,
									insured_SSN: beneficiaryAllDetails?.ssn,
									relation: beneficiaryAllDetails?.relationship,
									address_line_1: beneficiaryAllDetails?.address,
									address_line_2: beneficiaryAllDetails?.address2,
									state: beneficiaryAllDetails?.state,
									ZIP: beneficiaryAllDetails?.zipCode,
									SSN: beneficiaryAllDetails?.ssn,
									date_of_birth:
										beneficiaryAllDetails.dob !== ""
											? new Date(beneficiaryAllDetails.date_of_birth)
											: new Date(),
									gender: beneficiaryAllDetails?.gender,
									percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
									phone_number: beneficiaryAllDetails.telephone,
									canEdit: true
								};
								setAddMemberPrimaryBeneficiary([...addMemberPrimaryBeneficiary, newBeneficiary]);
							} else {
								if (editData !== null) {
									const editedMemberContigentBeneficiary = addMemberContigentBeneficiary.map(
										(memberPrimary: Beneficiary, index: number) => {
											if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
												return {
													first_name: beneficiaryAllDetails?.firstName,
													last_name: beneficiaryAllDetails?.lastName,
													type: beneficiaryAllDetails.type,
													enrollment_id: beneficiaryAllDetails?._id,
													insured_SSN: beneficiaryAllDetails?.ssn,
													relation: beneficiaryAllDetails?.relationship,
													address_line_1: beneficiaryAllDetails?.address,
													address_line_2: beneficiaryAllDetails?.address2,
													state: beneficiaryAllDetails?.state,
													ZIP: beneficiaryAllDetails?.zipCode,
													SSN: beneficiaryAllDetails?.ssn,
													date_of_birth:
														beneficiaryAllDetails.dob !== ""
															? new Date(beneficiaryAllDetails.date_of_birth)
															: new Date(),
													gender: beneficiaryAllDetails?.gender,
													percentage: parseInt(
														beneficiaryAllDetails.percentage.substring(0, 2)
													),
													phone_number: beneficiaryAllDetails.telephone,
													canEdit: true
												};
											} else {
												return memberPrimary;
											}
										}
									);
									setAddMemberContigentBeneficiary(editedMemberContigentBeneficiary);
									setEditData(null);
								} else {
									const newBeneficiary: Beneficiary = {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
									setAddMemberContigentBeneficiary([
										...addMemberContigentBeneficiary,
										newBeneficiary
									]);
								}
							}
						}
					} else {
						alert("Percentage should be less tha 100. Please delete any beneficiary");
						setModalOpen(false);
					}
				} else {
					if (editData !== null) {
						const editedSpousePrimaryBeneficiary = addSpousePrimaryBeneficiary.map(
							(SpousePrimary: Beneficiary, index: number) => {
								if (SpousePrimary.enrollment_id === beneficiaryAllDetails._id) {
									return {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
								} else {
									return SpousePrimary;
								}
							}
						);
						setAddSpousePrimaryBeneficiary(editedSpousePrimaryBeneficiary);
						const editedSpouseContingentBeneficiary = addSpouseContigentBeneficiary.map(
							(SpousePrimary: Beneficiary, index: number) => {
								if (SpousePrimary.enrollment_id === beneficiaryAllDetails._id) {
									return {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
								} else {
									return SpousePrimary;
								}
							}
						);
						setAddSpouseContigentBeneficiary(editedSpouseContingentBeneficiary);
						setEditData(null);
					} else {
						if (
							(primarySpouseBeneficiary.percentage +
								contingentSpouseBeneficiary.percentage +
								parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
								200 &&
								(beneficiaryAllDetails.type === "PRIMARY"
									? primarySpouseBeneficiary.percentage +
											parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
									  100
									: contingentSpouseBeneficiary.percentage +
											parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
									  100)) ||
							editData !== null
						) {
							if ([...addSpousePrimaryBeneficiary, ...addSpouseContigentBeneficiary].length > 1) {
								alert("Max 2 beneficiary can be added");
								setModalOpen(false);
								return 0;
							}
							if (beneficiaryAllDetails.type === "PRIMARY") {
								if (editData !== null) {
									const editedSpousePrimaryBeneficiary = addSpousePrimaryBeneficiary.map(
										(memberPrimary: Beneficiary, index: number) => {
											if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
												return {
													first_name: beneficiaryAllDetails?.firstName,
													last_name: beneficiaryAllDetails?.lastName,
													type: beneficiaryAllDetails.type,
													enrollment_id: beneficiaryAllDetails?._id,
													insured_SSN: beneficiaryAllDetails?.ssn,
													relation: beneficiaryAllDetails?.relationship,
													address_line_1: beneficiaryAllDetails?.address,
													address_line_2: beneficiaryAllDetails?.address2,
													state: beneficiaryAllDetails?.state,
													ZIP: beneficiaryAllDetails?.zipCode,
													SSN: beneficiaryAllDetails?.ssn,
													date_of_birth:
														beneficiaryAllDetails.dob !== ""
															? new Date(beneficiaryAllDetails.date_of_birth)
															: new Date(),
													gender: beneficiaryAllDetails?.gender,
													percentage: parseInt(
														beneficiaryAllDetails.percentage.substring(0, 2)
													),
													phone_number: beneficiaryAllDetails.telephone,
													canEdit: true
												};
											} else {
												return memberPrimary;
											}
										}
									);
									setAddSpousePrimaryBeneficiary(editedSpousePrimaryBeneficiary);
									setEditData(null);
								} else {
									const newBeneficiary: Beneficiary = {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
									setAddSpousePrimaryBeneficiary([...addSpousePrimaryBeneficiary, newBeneficiary]);
								}
							} else {
								if (editData !== null) {
									const editedSpouseContigentBeneficiary = addSpouseContigentBeneficiary.map(
										(memberPrimary: Beneficiary, index: number) => {
											if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
												return {
													first_name: beneficiaryAllDetails?.firstName,
													last_name: beneficiaryAllDetails?.lastName,
													type: beneficiaryAllDetails.type,
													enrollment_id: beneficiaryAllDetails?._id,
													insured_SSN: beneficiaryAllDetails?.ssn,
													relation: beneficiaryAllDetails?.relationship,
													address_line_1: beneficiaryAllDetails?.address,
													address_line_2: beneficiaryAllDetails?.address2,
													state: beneficiaryAllDetails?.state,
													ZIP: beneficiaryAllDetails?.zipCode,
													SSN: beneficiaryAllDetails?.ssn,
													date_of_birth:
														beneficiaryAllDetails.dob !== ""
															? new Date(beneficiaryAllDetails.date_of_birth)
															: new Date(),
													gender: beneficiaryAllDetails?.gender,
													percentage: parseInt(
														beneficiaryAllDetails.percentage.substring(0, 2)
													),
													phone_number: beneficiaryAllDetails.telephone,
													canEdit: true
												};
											} else {
												return memberPrimary;
											}
										}
									);
									setAddSpouseContigentBeneficiary(editedSpouseContigentBeneficiary);
									setEditData(null);
								} else {
									const newBeneficiary: Beneficiary = {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
									setAddSpouseContigentBeneficiary([
										...addSpouseContigentBeneficiary,
										newBeneficiary
									]);
								}
							}
						} else {
							alert("Percentage should be less tha 100. Please delete any beneficiary");
							setModalOpen(false);
						}
					}
				}
				setModalOpen(false);
			} else {
				setModalOpen(false);
			}
			// const { name, checked } = event.target;
			// if (name === "member-death-chronic-illness") {
			// 	setHasMemberAccidentalDeath(checked);
			// } else {
			// 	setHasSpouseAccidentalDeath(checked);
			// }
		},
		[
			selectCard,
			primaryMemberBeneficiary.percentage,
			contingentMemberBeneficiary.percentage,
			editData,
			addMemberPrimaryBeneficiary,
			addMemberContigentBeneficiary,
			addSpousePrimaryBeneficiary,
			addSpouseContigentBeneficiary,
			primarySpouseBeneficiary.percentage,
			contingentSpouseBeneficiary.percentage
		]
	);

	const handleClose = () => {
		setModalOpen(false);
		setEditData(null);
	};

	const handleEdit = useCallback((data: Beneficiary, cardId: string) => {
		setSelectCard(cardId);
		setEditData(data);
		setModalOpen(true);
	}, []);

	const handleDelete = useCallback(
		(data: Beneficiary, cardId: string) => {
			setSelectCard(cardId);
			if (cardId === "member-card" && data.type === "PRIMARY") {
				setAddMemberPrimaryBeneficiary(
					addMemberPrimaryBeneficiary.filter((val: Beneficiary, index: number) => {
						return val.enrollment_id !== data.enrollment_id;
					})
				);
			} else if (cardId === "member-card" && data.type === "CONTINGENT") {
				setAddMemberContigentBeneficiary(
					addMemberContigentBeneficiary.filter((val: Beneficiary, index: number) => {
						return val.enrollment_id !== data.enrollment_id;
					})
				);
			} else if (cardId === "spouse-card" && data.type === "CONTINGENT") {
				setAddSpouseContigentBeneficiary(
					addSpouseContigentBeneficiary.filter((val: Beneficiary, index: number) => {
						return val.enrollment_id !== data.enrollment_id;
					})
				);
			} else {
				setAddSpousePrimaryBeneficiary(
					addSpousePrimaryBeneficiary.filter((val: Beneficiary, index: number) => {
						return val.enrollment_id !== data.enrollment_id;
					})
				);
			}
		},
		[
			addMemberPrimaryBeneficiary,
			addMemberContigentBeneficiary,
			addSpousePrimaryBeneficiary,
			addSpouseContigentBeneficiary
		]
	);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const [questions] = useState<FiveStarInsuranceQuestions[]>(fiveStarInsurancePlanQuestions);

	const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
		setExpanded(newExpanded ? panel : false);
	};

	const handleBeneficiaryChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
		setExpandedPanel(newExpanded ? panel : false);
	};

	// useEffect(() => {
	// 	if (coverage_for === "Employee Only") {
	// 		setMaxBenefitMember(
	// 			JSON.parse(JSON.stringify(maxBenefitMember.filter((employee: Member) => employee.SSN === member.SSN)))
	// 		);
	// 	} else if (coverage_for === "Employee & Spouse") {
	// 		setMaxBenefitMember(
	// 			JSON.parse(
	// 				JSON.stringify(
	// 					maxBenefitMember.filter(
	// 						(employee: Member) => employee.SSN === member.SSN || employee.SSN === spouse?.SSN
	// 					)
	// 				)
	// 			)
	// 		);
	// 	} else if (coverage_for === "Spouse Only") {
	// 		setMaxBenefitMember(
	// 			JSON.parse(JSON.stringify(maxBenefitMember.filter((employee: Member) => employee.SSN === spouse?.SSN)))
	// 		);
	// 	} else if (coverage_for === "Employee & Children") {
	// 		const children_ssn: string[] = children.map((child: Member) => {
	// 			return child.SSN;
	// 		});
	// 		setMaxBenefitMember(
	// 			JSON.parse(
	// 				JSON.stringify(
	// 					maxBenefitMember.filter(
	// 						(employee: Member) => employee.SSN === member?.SSN || children_ssn.includes(employee.SSN)
	// 					)
	// 				)
	// 			)
	// 		);
	// 	} else if (coverage_for === "Spouse and Children") {
	// 		const children_ssn: string[] = children.map((child: Member) => {
	// 			return child.SSN;
	// 		});
	// 		setMaxBenefitMember(
	// 			JSON.parse(
	// 				JSON.stringify(
	// 					maxBenefitMember.filter(
	// 						(employee: Member) => employee.SSN === spouse?.SSN || children_ssn.includes(employee.SSN)
	// 					)
	// 				)
	// 			)
	// 		);
	// 	}
	// }, [children, coverage_for, maxBenefitMember, member.SSN, spouse?.SSN]);

	const handleCoverageChange = useCallback(
		(event: React.FormEvent<HTMLSelectElement>) => {
			const { value } = event.target as HTMLSelectElement;
			if (value === "Employee Only") {
				setSpouseBenefitAmount(0);
				setChildBenefitAmount(0);
				setSpouseStandardPremiumAmount(0);
				setChildStandardPremiumAmount(0);
				setMaxBenefitMember(
					JSON.parse(
						JSON.stringify(maxBenefitMember.filter((employee: Member) => employee.SSN === member.SSN))
					)
				);
			} else if (value === "Employee & Spouse") {
				setChildBenefitAmount(0);
				setChildStandardPremiumAmount(0);
				setMaxBenefitMember(
					JSON.parse(
						JSON.stringify(
							maxBenefitMember.filter(
								(employee: Member) => employee.SSN === member.SSN || employee.SSN === spouse?.SSN
							)
						)
					)
				);
			} else if (value === "Employee & Children") {
				setSpouseBenefitAmount(0);
				setSpouseStandardPremiumAmount(0);
				const children_ssn: string[] = children.map((child: Member) => {
					return child.SSN;
				});
				setMaxBenefitMember(
					JSON.parse(
						JSON.stringify(
							maxBenefitMember.filter(
								(employee: Member) =>
									employee.SSN === member?.SSN || children_ssn.includes(employee.SSN)
							)
						)
					)
				);
			} else if (value === "Spouse Only") {
				setEmployeeBenefitAmount(0);
				setChildBenefitAmount(0);
				setEmployeeStandardPremiumAmount(0);
				setChildStandardPremiumAmount(0);
				setMaxBenefitMember(
					JSON.parse(
						JSON.stringify(maxBenefitMember.filter((employee: Member) => employee.SSN === spouse?.SSN))
					)
				);
			} else if (value === "Spouse & Children") {
				setEmployeeBenefitAmount(0);
				setEmployeeStandardPremiumAmount(0);
				const children_ssn: string[] = children.map((child: Member) => {
					return child.SSN;
				});
				setMaxBenefitMember(
					JSON.parse(
						JSON.stringify(
							maxBenefitMember.filter(
								(employee: Member) =>
									employee.SSN === spouse?.SSN || children_ssn.includes(employee.SSN)
							)
						)
					)
				);
			}
			setAnswerList(JSON.parse(JSON.stringify([])));
			setAllAnswerRecord(JSON.parse(JSON.stringify([])));
			setCoverageFor(value);
		},
		[children, maxBenefitMember, member.SSN, spouse?.SSN]
	);

	const handlePlanChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = event.target as HTMLSelectElement;
		setPlanType(value);
	};

	const manageMaxBenefitMember = useCallback(
		(member: Member, isMaxBenefit: boolean) => {
			isMaxBenefit
				? maxBenefitMember.some((employee: Member) => employee.SSN === member.SSN)
					? setMaxBenefitMember(maxBenefitMember)
					: setMaxBenefitMember([...maxBenefitMember, member])
				: setMaxBenefitMember(maxBenefitMember.filter((consumer: Member) => consumer.SSN != member.SSN));
		},
		[maxBenefitMember]
	);

	const handleBenefitAmountChange = useCallback(
		(event: React.ChangeEvent<HTMLSelectElement>) => {
			const { name, value } = event.target as HTMLSelectElement;
			const isMaxBenefitAmountSelected = Number(value) > MAX_BENEFIT_THRESHOLD ? true : false;
			if (isMaxBenefitAmountSelected === true) {
				alert(
					`As you selected more than benefit ${MAX_BENEFIT_THRESHOLD} amount, you have to answer the below questions.`
				);
			}
			if (name === "member_face_amount") {
				setEmployeeBenefitAmount(parseInt(value));
				manageMaxBenefitMember(member, isMaxBenefitAmountSelected);
			} else if (name === "spouse_face_amount") {
				setSpouseBenefitAmount(parseInt(value));
				spouse && manageMaxBenefitMember(spouse, isMaxBenefitAmountSelected);
			} else if (name === "child_face_amount") {
				setChildBenefitAmount(parseInt(value));
				children.map((child: Member) => manageMaxBenefitMember(child, isMaxBenefitAmountSelected));
			} else {
				setEmployeeBenefitAmount(0);
				setSpouseBenefitAmount(0);
				setChildBenefitAmount(0);
			}
			const answer_data: AnswerData[] = [];
			maxBenefitMember.forEach((benefitMember: Member) => {
				const answeredMember = answerList.filter((ans: AnswerData) => ans?.SSN === benefitMember.SSN);
				answeredMember.forEach((answer: AnswerData) => {
					answer_data.push(answer);
				});
			});
			setAnswerList(JSON.parse(JSON.stringify([...answer_data])));
		},
		[answerList, children, manageMaxBenefitMember, maxBenefitMember, member, spouse]
	);

	const handleAnswerChange = useCallback(
		(event: React.FormEvent<HTMLSelectElement>) => {
			const { name, value } = event.target as HTMLSelectElement;
			const answerSplitArray = name.split("-");
			const quesNo = answerSplitArray[1];
			const answerForSSN = answerSplitArray[2];
			if (value === "yes") {
				alert(
					`You can get the benefit amount more than ${MAX_BENEFIT_THRESHOLD} only if you do not have this problem`
				);
				if (answerForSSN === "all") {
					console.log(answerForSSN);
					let answer_data: AnswerData[] = answerList;
					maxBenefitMember.forEach((benefitMember: Member) => {
						answer_data = answer_data.filter(
							(answer: AnswerData) =>
								(answer?.questionNo === quesNo && answer?.SSN === benefitMember.SSN) === false
						);
					});
					setAnswerList(JSON.parse(JSON.stringify([...answer_data])));
					const all_answer_record: string[] = allAnswerRecord.filter(
						(questionNumber: string) => questionNumber !== quesNo
					);
					setAllAnswerRecord([...all_answer_record]);
				} else {
					const removeExistingAnswer: AnswerData[] = answerList.filter(
						(ans: AnswerData) => (ans.questionNo === quesNo && ans.SSN === answerForSSN) === false
					);
					setAnswerList(JSON.parse(JSON.stringify([...removeExistingAnswer])));
					if (allAnswerRecord.some((questionNumber: string) => questionNumber === quesNo)) {
						const all_answer_record: string[] = allAnswerRecord.filter(
							(questionNumber: string) => questionNumber !== quesNo
						);
						setAllAnswerRecord([...all_answer_record]);
					}
				}
				event.preventDefault();
			} else {
				if (answerForSSN === "all") {
					const answer_data: AnswerData[] = [];
					maxBenefitMember.forEach((benefitMember: Member) => {
						const answeredMember =
							answerList.length > 0 &&
							answerList.find(
								(ans: AnswerData) => ans?.questionNo === quesNo && ans?.SSN === benefitMember.SSN
							);
						if (!answeredMember) {
							answer_data.push({
								questionNo: quesNo,
								SSN: benefitMember.SSN,
								member: benefitMember,
								answer: value
							});
						}
					});
					setAnswerList(JSON.parse(JSON.stringify([...answerList, ...answer_data])));
					if (!allAnswerRecord.some((questionNumber: string) => questionNumber === quesNo)) {
						setAllAnswerRecord([...allAnswerRecord, quesNo]);
					}
				} else {
					const answerFor = maxBenefitMember.find(
						(benefitMember: Member) => benefitMember.SSN == answerForSSN
					);
					const removeExistingAnswer: AnswerData[] = answerList.filter(
						(ans: AnswerData) => (ans.questionNo === quesNo && ans.SSN === answerForSSN) === false
					);
					if (answerFor) {
						const answer_data: AnswerData = {
							questionNo: quesNo,
							SSN: answerForSSN,
							member: answerFor,
							answer: value
						};
						setAnswerList(JSON.parse(JSON.stringify([...removeExistingAnswer, answer_data])));
					}
				}
			}
		},
		[allAnswerRecord, answerList, maxBenefitMember]
	);

	const handleWritingNumberChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { value } = event.target as HTMLInputElement;
			setWritingNumber(Number(value));
			if (Number(value) !== prevWritingNumber) {
				setShowWritingNumberValidateButton(true);
			} else {
				setShowWritingNumberValidateButton(false);
			}
		},
		[prevWritingNumber]
	);

	const [enrollmentDisclaimerDialogProps, setEnrollmentDisclaimerDialogProps] =
		useState<CustomDisclaimerDialogPropsType>({
			openDialog: false,
			title: "Disclaimer",
			content:
				"I represent to the best of my knowledge and belief that all statements and answers in this application are complete, true and correctly recorded, and are made as a consideration for the applied for insurance . I understand that 5Star Life Insurance Company (5Star Life) will rely on my statements and answers as being true and complete in deciding whether to issue insurance on the proposed insured(s) and understand that 5Star will have the right to verify prescription history as part of this process, as needed. 5Star Life may rescind the policy in accordance with the Contestability provision of the Policy due to any material misrepresentation of fact made in this application. Insurance is effective under the policy only when it is delivered to the owner, and then only if the full first premium is paid and all of the statements in this application remain correct and complete.",
			importantTitle: "NOTE",
			importantContent:
				"Any person who knowingly presents a false statement in an application for insurance may be guilty of a criminal offense and subject to penalties under state law. I certify I have authorized my employer to make payroll deduction of premiums for myself and my family members.",
			inputFields: [
				{
					name: "Email Discalimer",
					value: emailDisclaimer,
					placeholder: "Enter Email"
				}
			],
			actions: [
				{
					label: "Email Disclaimer",
					callback: () => {
						null;
						// setEnrollmentDisclaimerDialogProps(
						// 	Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
						// );
					}
				}
			]
		});

	const [questionDisclaimerDialogProps, setQuestionDisclaimerDialogProps] = useState<CustomDisclaimerDialogPropsType>(
		{
			openDialog: false,
			title: "Disclaimer",
			content: `As you selected more than benefit ${MAX_BENEFIT_THRESHOLD} amount, you have to answer the below questions.`,
			importantTitle: "IMPORTANT",
			importantContent: "",
			inputFields: [],
			actions: [
				{
					label: "Question Disclaimer",
					callback: () => {
						setQuestionDisclaimerDialogProps(
							Object.assign({}, questionDisclaimerDialogProps, { openDialog: false })
						);
					}
				}
			]
		}
	);

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || VEBOpenEnrollment === null) {
			return;
		}
		const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } = generateCancerKemperWaiveEnrollmentPayload(
			familyProtectionPlan,
			VEB_PLAN_NAME.five_star.family_protection.standard_family_protection,
			VEB_PLAN_NAME.five_star.family_protection.standard_family_protection,
			null,
			groupOwner,
			member,
			waiveReason,
			VEBOpenEnrollmentId as unknown as string,
			false
		);
		const VEBEnrollmentPayload: VEBEnrollmentPayload = {
			standard_details: VEBEnrollmentStandardDetails,
			common_details: VEBEnrollmentCommonDetails,
			isRider: false
		};
		const response = await api.enrollment.addVEBEnrollment(VEBEnrollmentPayload);
		deleteCurrentEnrollment();
		console.log("response", response);
	}, [
		member,
		VEBOpenEnrollment,
		familyProtectionPlan,
		groupOwner,
		waiveReason,
		VEBOpenEnrollmentId,
		deleteCurrentEnrollment
	]);

	const handleWaiveButtonClick = useCallback((): void => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							handleWaiveEnrollment();
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, waiveReason]);

	const handleOpenDisclaimerDialogClick = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: true }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleCloseDisclaimerDialog = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleEscapeCloseDisclaimerDialog = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			const Key = event.key;

			if (Key === "Escape")
				setEnrollmentDisclaimerDialogProps(
					Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
				);
		},
		[enrollmentDisclaimerDialogProps]
	);

	const handleAgreedTCCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setHasReadTC(checked);
	};

	const handleIsActivelyWorkingCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIsActivelyWorking(checked);
	};

	const handleValidation = useCallback((): boolean => {
		console.log(1121212, answerList, maxBenefitMember);
		if (coverage_for === null || plan_type === "") {
			alert("Please select the plan type and coverage for");
			return false;
		}
		if (employeeBenefitAmount === 0 && spouseBenefitAmount === 0 && childBenefitAmount === 0) {
			alert("Please select the benefit amount");
			return false;
		}
		if (hasReadTC === false) {
			alert("Please agree to the Disclaimer");
			return false;
		}
		if (isActivelyWorking === false) {
			alert("You must actively working 20 hours or more to enroll");
			return false;
		}
		if (maxBenefitMember.length > 0) {
			let allQuestionsAnswered = true;
			maxBenefitMember.forEach((member: Member) => {
				const answer_list = answerList.filter((answer: AnswerData) => answer.SSN === member.SSN).length;
				if (answer_list < 7) {
					allQuestionsAnswered = false;
				}
			});
			if (!allQuestionsAnswered) {
				alert("Please answer all the questions");
				return false;
			}
		}
		return true;
	}, [
		answerList,
		maxBenefitMember,
		coverage_for,
		plan_type,
		employeeBenefitAmount,
		spouseBenefitAmount,
		childBenefitAmount,
		hasReadTC,
		isActivelyWorking
	]);

	const generatePayload = useCallback(
		(VEBEnrollments: VEBWholeLifeEnrollments[], VEBOpenEnrollment: VEBOpenEnrollment[], paycheck: Paycheck) => {
			const VEBEnrollmentPayload: VEBEnrollmentPayload = {
				isRider: false,
				standard_details: [],
				common_details: {
					agent_id: groupOwner?._id as unknown as string,
					location_number: 0,
					location_name: "",
					group_number: 0,
					group_name: "",
					plan_object_id: "",
					plan_code: "",
					plan_name: "",
					base_plan_name: "",
					sub_plan: null,
					insured_object_id: "",
					insured_SSN: "",
					enrollment_status: null,
					unenrolled_reason: null,
					waive_reason: null,
					termination_reason: null,
					writing_number: 0,
					enrollment_date: null,
					effective_date: null,
					termination_date: null,
					open_enrollment_id: null,
					total_premium: 0,
					enrollment_paycheck_id: undefined
				}
			};
			VEBEnrollments.forEach(async (VEBEnrollment: VEBWholeLifeEnrollments, index: number) => {
				const {
					plan,
					premiumAmount,
					VEB_primary_beneficiary,
					VEB_contingent_beneficiary,
					totalPremium,
					coverageCode,
					benefitAmount,
					planName,
					subPlan,
					planFor
				} = VEBEnrollment;
				if (planFor?.SSN) {
					const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } =
						generateWholeLifeActivateVEBEnrollmentPayload(
							plan,
							groupOwner,
							member,
							planFor,
							benefitAmount,
							coverageCode,
							premiumAmount,
							planName,
							totalPremium,
							familyProtectionPlan.plan_name,
							subPlan,
							VEBOpenEnrollmentId as unknown as string,
							paycheck,
							VEB_primary_beneficiary,
							VEB_contingent_beneficiary,
							writingNumber
						);
					VEBEnrollmentPayload.common_details = VEBEnrollmentCommonDetails;
					VEBEnrollmentPayload.standard_details.push(VEBEnrollmentStandardDetails);
				}
			});
			return VEBEnrollmentPayload;
		},
		[groupOwner, member, familyProtectionPlan.plan_name, VEBOpenEnrollmentId, writingNumber]
	);

	const handleActivateButtonClick = useCallback(async () => {
		const isValid = handleValidation();
		const beneficiaryIsValidation = handleBeneficiaryValidate();
		if (isValid === false || member === null || beneficiaryIsValidation === false) {
			return;
		}
		if (member && VEBOpenEnrollment && paycheck) {
			// Create enrollment for standard plan
			// Member standard plan
			const VEBStandardEnrollments: VEBWholeLifeEnrollments[] = [];
			const coverage_code: CoverageCode =
				spouseBenefitAmount && spouseBenefitAmount > 0 && childBenefitAmount && childBenefitAmount > 0
					? "EF"
					: spouseBenefitAmount && spouseBenefitAmount > 0 && childBenefitAmount && childBenefitAmount <= 0
					? "ES"
					: childBenefitAmount && childBenefitAmount > 0 && spouseBenefitAmount && spouseBenefitAmount <= 0
					? "ECH"
					: "EE";

			//Employee standard plan
			if (employeeBenefitAmount && employeeBenefitAmount > 0) {
				VEBStandardEnrollments.push({
					plan: familyProtectionPlan,
					premiumAmount: employeeStandardPremiumAmount,
					totalPremium: Number(totalPremiumAmount.toFixed(2)),
					coverageCode: coverage_code,
					benefitAmount: employeeBenefitAmount,
					planName: "Family Protection",
					subPlan: null,
					planFor: member,
					VEB_primary_beneficiary: BV2employeePrimaryBeneficiary,
					VEB_contingent_beneficiary: BV2employeeContingentBeneficiary
				});
			}

			//Employee standard plan with zero benefit amount
			if (coverage_for === "Spouse Only" || coverage_for === "Spouse & Children") {
				VEBStandardEnrollments.push({
					plan: familyProtectionPlan,
					premiumAmount: 0,
					totalPremium: Number(totalPremiumAmount.toFixed(2)),
					coverageCode: coverage_code,
					benefitAmount: 0,
					planName: "Family Protection",
					subPlan: null,
					planFor: member,
					VEB_primary_beneficiary: [],
					VEB_contingent_beneficiary: []
				});
			}

			// Spouse standard plan
			if (spouse && spouseBenefitAmount > 0) {
				VEBStandardEnrollments.push({
					plan: familyProtectionPlan,
					premiumAmount: spouseStandardPremiumAmount,
					totalPremium: Number(totalPremiumAmount.toFixed(2)),
					coverageCode: coverage_code,
					benefitAmount: spouseBenefitAmount,
					planName: "Family Protection",
					subPlan: null,
					planFor: spouse,
					VEB_primary_beneficiary: BV2spousePrimaryBeneficiary,
					VEB_contingent_beneficiary: BV2spouseContingentBeneficiary
				});
			}

			//Child standard plan
			if (childBenefitAmount && childBenefitAmount > 0) {
				children.forEach((child, index) => {
					VEBStandardEnrollments.push({
						plan: familyProtectionPlan,
						premiumAmount: childStandardPremiumAmount,
						totalPremium: Number(totalPremiumAmount.toFixed(2)),
						coverageCode: coverage_code,
						benefitAmount: childBenefitAmount,
						planName: "Family Protection",
						subPlan: null,
						planFor: child,
						VEB_primary_beneficiary: BV2childPrimaryBeneficiary,
						VEB_contingent_beneficiary: BV2childContingentBeneficiary
					});
				});
			}

			console.log("VEBEnrollments", VEBStandardEnrollments);

			const VEBStandardEnrollmentPayload: VEBEnrollmentPayload = generatePayload(
				VEBStandardEnrollments,
				VEBOpenEnrollment,
				paycheck
			);

			await trackPromise(api.enrollment.addVEBEnrollment(VEBStandardEnrollmentPayload));
			getVEBEnrollmentInitData();
			deleteCurrentEnrollment();
			const step = urlSearchParams.get("step");
			history.push(`?step=${step}&stage=2`);
		}
	}, [
		handleValidation,
		handleBeneficiaryValidate,
		member,
		VEBOpenEnrollment,
		paycheck,
		spouseBenefitAmount,
		childBenefitAmount,
		employeeBenefitAmount,
		coverage_for,
		spouse,
		generatePayload,
		getVEBEnrollmentInitData,
		deleteCurrentEnrollment,
		urlSearchParams,
		history,
		familyProtectionPlan,
		employeeStandardPremiumAmount,
		totalPremiumAmount,
		BV2employeePrimaryBeneficiary,
		BV2employeeContingentBeneficiary,
		spouseStandardPremiumAmount,
		BV2spousePrimaryBeneficiary,
		BV2spouseContingentBeneficiary,
		children,
		childStandardPremiumAmount,
		BV2childPrimaryBeneficiary,
		BV2childContingentBeneficiary
	]);

	useEffect(() => {
		const dependentCoverage = getFiveStarEligibleDependents(dependents, member);
		const newCoverage = dependentCoverage.coverage.filter((eachCoverage: string) => {
			if (["Employee & Spouse", "Spouse Only"].includes(eachCoverage)) {
				return true;
			} else {
				return false;
			}
		});
		setFiveStarPlan((prevFiveStartPlanDetails: FiveStarPlanDetails) => {
			return Object.assign({}, prevFiveStartPlanDetails, {
				coverage: dependentCoverage.coverage
			});
		});
		setEligiblityDialogProps((prevEligiblityDialogProps: EligiblityDialogProps) => {
			return Object.assign({}, prevEligiblityDialogProps, {
				openDialog: true,
				eligibleDependents: Object.assign([], dependentCoverage.dependents),
				ineligibleRelationshipDependents: Object.assign([], dependentCoverage.ineligibleRelationshipDependents),
				ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
			});
		});
		setEligiblity(
			Object.assign(
				{},
				{
					eligibleDependents: Object.assign([], dependentCoverage.dependents),
					ineligibleRelationshipDependents: Object.assign(
						[],
						dependentCoverage.ineligibleRelationshipDependents
					),
					ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
				}
			)
		);
		maxBenefitMember.length > 0 ? setExpanded("panel_question") : setExpanded(false);
	}, [dependents, maxBenefitMember, member, setEligiblity]);

	useEffect(() => {
		const spouse = dependents.find((dependent: Member) => dependent.relationship === "SPOUSE");
		if (spouse) {
			const spouseAge = calculateAge(
				new Date(spouse.date_of_birth) as unknown as string,
				planCode === "FP-ALL-2024"
					? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
					: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD
			);
			if (spouse && spouseAge >= 18 && spouseAge <= 70) {
				setSpouse(spouse);
			}
		}

		const ECHRelationship = ["SON", "CHILD", "DAUGHTER", "STEP CHILD"];
		const children = dependents.filter((child: Member) => {
			const relationship = child.relationship !== null ? child.relationship : "";
			if (ECHRelationship.includes(relationship)) {
				const childDOB: Date = child.date_of_birth === undefined ? new Date() : new Date(child.date_of_birth);
				const age = calculateAge(
					childDOB as unknown as string,
					planCode === "FP-ALL-2024"
						? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
						: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD
				);
				if (
					((age >= 1 && age < 19) || (getAgeInDays(child.date_of_birth) >= 14 && age < 19)) &&
					child.marital_status !== "MARRIED"
				) {
					return child;
				}
			}
		});
		setChildren(children);
		const allMembers: Member[] = [member];
		if (spouse) {
			allMembers.push(spouse);
		}
		if (children.length > 0) {
			allMembers.push(children[0]);
		}
		setEligibleMembers(allMembers);
	}, [member, dependents, answerList]);

	useEffect(() => {
		if (member) {
			let employeeStandardPremiumAmount = 0;
			let spouseStandardPremiumAmount = 0;
			let childStandardPremiumAmount = 0;
			let totalPremiumAmount = 0;

			// Calculate employee premium amount
			//Standard
			const employeeAge = calculateAge(
				new Date(member.date_of_birth) as unknown as string,
				planCode === "FP-ALL-2024"
					? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
					: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD
			).toString();
			//const employeeAge = 18;
			if (
				paycheck &&
				coverage_for !== "" &&
				employeeBenefitAmount !== null &&
				employeeBenefitAmount > 0 &&
				plan_type !== ""
			) {
				employeeStandardPremiumAmount =
					fiveStarPlan.premium_amount[employeeAge as keyof FiveStarAge][
						"standard_premium" as keyof FiveStarStandardPremiumAmount
					][employeeBenefitAmount.toString() as keyof FiveStarFaceAmountFrequency][
						paycheck.pay_frequency as keyof PaycheckFrequency
					];
				setEmployeeStandardPremiumAmount(employeeStandardPremiumAmount);
			}

			//Calculate spouse premium amount
			//Standard
			const spouseAge =
				spouse?.date_of_birth &&
				calculateAge(
					new Date(spouse.date_of_birth) as unknown as string,
					planCode === "FP-ALL-2024"
						? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
						: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD
				).toString();
			//const spouseAge = 18;
			if (
				paycheck &&
				coverage_for !== "" &&
				spouseBenefitAmount !== null &&
				spouseBenefitAmount > 0 &&
				plan_type !== ""
			) {
				spouseStandardPremiumAmount =
					fiveStarPlan.premium_amount[spouseAge as keyof FiveStarAge][
						"standard_premium" as keyof FiveStarStandardPremiumAmount
					][spouseBenefitAmount.toString() as keyof FiveStarFaceAmountFrequency][
						paycheck.pay_frequency as keyof PaycheckFrequency
					];
				setSpouseStandardPremiumAmount(spouseStandardPremiumAmount);
			}

			//Calculate child premium amount
			//Standard
			//const childAge = children[0]?.date_of_birth && calculateAge(new Date(children[0].date_of_birth)).toString();
			const childAge = 20;
			if (
				paycheck &&
				coverage_for !== "" &&
				childBenefitAmount !== null &&
				childBenefitAmount > 0 &&
				plan_type !== "" &&
				paycheck
			) {
				if (paycheck.pay_frequency === "MONTHLY") {
					if (childBenefitAmount === 5000) {
						childStandardPremiumAmount = 1.0;
					} else if (childBenefitAmount === 10000) {
						childStandardPremiumAmount = 2.0;
					}
				} else if (paycheck.pay_frequency === "WEEKLY") {
					if (childBenefitAmount === 5000) {
						childStandardPremiumAmount = 0.25;
					} else if (childBenefitAmount === 10000) {
						childStandardPremiumAmount = 0.5;
					}
				} else {
					childStandardPremiumAmount = 0;
				}
				setChildStandardPremiumAmount(childStandardPremiumAmount);
			} else {
				setChildStandardPremiumAmount(0);
			}

			//Calculate total premium amount
			totalPremiumAmount =
				employeeStandardPremiumAmount + spouseStandardPremiumAmount + childStandardPremiumAmount;
			setTotalPremiumAmount(totalPremiumAmount);
			setCurrentEnrollment(
				Object.assign(
					{},
					{
						plan_name: "Family Protection",
						status: "Current",
						premium_amount: Number(totalPremiumAmount.toFixed(2))
					}
				)
			);
		}
	}, [
		coverage_for,
		plan_type,
		employeeBenefitAmount,
		spouseBenefitAmount,
		childBenefitAmount,
		employeeStandardPremiumAmount,
		spouseStandardPremiumAmount,
		childStandardPremiumAmount,
		totalPremiumAmount,
		maxBenefitMember,
		answerList,
		member,
		paycheck,
		spouse,
		children,
		fiveStarPlan.premium_amount,
		setCurrentEnrollment,
		planCode
	]);

	useEffect(() => {
		if (coverage_for && member) {
			if (
				coverage_for === "Employee Only" ||
				coverage_for === "Employee & Children" ||
				coverage_for === "Employee & Family" ||
				coverage_for === "Employee & Spouse"
			) {
				if (spouse) {
					const newPrimaryBeneficiary: BV2Beneficiery = {
						first_name: spouse.first_name,
						middle_name: spouse.middle_name ? spouse.middle_name : "",
						last_name: spouse.last_name,
						type: "PRIMARY",
						insured_SSN: member.SSN,
						relationship: spouse.relationship,
						address_line_1: spouse.address_line_1,
						address_line_2: spouse.address_line_2,
						state: spouse.state,
						ZIP: spouse.ZIP,
						SSN: spouse.SSN,
						date_of_birth: dateTimeZoneConverter(spouse.date_of_birth) as unknown as string,
						gender: spouse.gender,
						percentage: 100,
						phone_number: spouse.phone_number
					};
					setBV2EmployeePrimaryBeneficiary(Object.assign([], [newPrimaryBeneficiary]));
				}
			}
			if (
				coverage_for === "Spouse Only" ||
				coverage_for === "Spouse & Children" ||
				coverage_for === "Employee & Spouse" ||
				coverage_for === "Employee & Family"
			) {
				const newPrimaryBeneficiary: BV2Beneficiery = {
					first_name: member.first_name,
					middle_name: member.middle_name ? member.middle_name : "",
					last_name: member.last_name,
					type: "PRIMARY",
					insured_SSN: member.SSN,
					relationship: member.relationship,
					address_line_1: member.address_line_1,
					address_line_2: member.address_line_2,
					state: member.state,
					ZIP: member.ZIP,
					SSN: member.SSN,
					date_of_birth: dateTimeZoneConverter(member.date_of_birth) as unknown as string,
					gender: member.gender,
					percentage: 100,
					phone_number: member.phone_number
				};
				setBV2SpousePrimaryBeneficiary(Object.assign([], [newPrimaryBeneficiary]));
			}
			if (
				coverage_for === "Employee & Children" ||
				coverage_for === "Employee & Family" ||
				coverage_for === "Spouse & Children"
			) {
				const newPrimaryBeneficiary: BV2Beneficiery = {
					first_name: member.first_name,
					middle_name: member.middle_name ? member.middle_name : "",
					last_name: member.last_name,
					type: "PRIMARY",
					insured_SSN: member.SSN,
					relationship: member.relationship,
					address_line_1: member.address_line_1,
					address_line_2: member.address_line_2,
					state: member.state,
					ZIP: member.ZIP,
					SSN: member.SSN,
					date_of_birth: dateTimeZoneConverter(member.date_of_birth) as unknown as string,
					gender: member.gender,
					percentage: 100,
					phone_number: member.phone_number
				};
				setBV2ChildPrimaryBeneficiary(Object.assign([], [newPrimaryBeneficiary]));
			}
		}
	}, [coverage_for, member, spouse]);

	useEffect(() => {
		let primaryMemberBeneficiaryCount = 0;
		let primaryMemberBeneficiaryPercentage = 0;
		let primarySpouseBeneficiaryCount = 0;
		let primarySpouseBeneficiaryPercentage = 0;
		let contingentMemberBeneficiaryCount = 0;
		let contingentMemberBeneficiaryPercentage = 0;
		let contingentSpouserBeneficiaryCount = 0;
		let contingentSpouseBeneficiaryPercentage = 0;
		if (selectCard === "member-card") {
			[...addMemberPrimaryBeneficiary, ...addMemberContigentBeneficiary].forEach(
				(element: Beneficiary, index: number) => {
					if (element.type === "PRIMARY") {
						primaryMemberBeneficiaryPercentage = primaryMemberBeneficiaryPercentage + element.percentage;
						primaryMemberBeneficiaryCount = primaryMemberBeneficiaryCount + 1;
					}
					if (element.type === "CONTINGENT") {
						contingentMemberBeneficiaryCount = contingentMemberBeneficiaryCount + 1;
						contingentMemberBeneficiaryPercentage =
							contingentMemberBeneficiaryPercentage + element.percentage;
					}
				}
			);
			setPrimaryMemberBeneficiary({
				percentage: primaryMemberBeneficiaryPercentage,
				count: primaryMemberBeneficiaryCount
			});
			setContingentMemberBeneficiary({
				percentage: contingentMemberBeneficiaryPercentage,
				count: contingentMemberBeneficiaryCount
			});
		} else {
			if (selectCard === "spouse-card") {
				[...addSpousePrimaryBeneficiary, ...addSpouseContigentBeneficiary].forEach(
					(element: Beneficiary, index: number) => {
						if (element.type === "PRIMARY") {
							primarySpouseBeneficiaryPercentage =
								primarySpouseBeneficiaryPercentage + element.percentage;
							primarySpouseBeneficiaryCount = primarySpouseBeneficiaryCount + 1;
						}
						if (element.type === "CONTINGENT") {
							contingentSpouseBeneficiaryPercentage =
								contingentSpouseBeneficiaryPercentage + element.percentage;
							contingentSpouserBeneficiaryCount = contingentSpouserBeneficiaryCount + 1;
						}
					}
				);
				setPrimarySpouseBeneficiary({
					percentage: primarySpouseBeneficiaryPercentage,
					count: primarySpouseBeneficiaryCount
				});
				setContingentSpouseBeneficiary({
					percentage: contingentSpouseBeneficiaryPercentage,
					count: contingentSpouserBeneficiaryCount
				});
			}
		}
	}, [
		addSpousePrimaryBeneficiary,
		addSpouseContigentBeneficiary,
		addMemberPrimaryBeneficiary,
		addMemberContigentBeneficiary,
		selectCard
	]);

	useEffect(() => {
		if (VEBOpenEnrollment && VEBOpenEnrollment.length !== 0) {
			getVEBPlanCode(VEBOpenEnrollment);
		}
	}, [VEBOpenEnrollment, getVEBPlanCode]);

	return (
		<Suspense fallback={<div />}>
			<Suspense fallback={<div />}>
				<CustomEnrollmentDisclaimerDialog
					enrollmentDisclaimerDialogProps={enrollmentDisclaimerDialogProps}
					handleCloseDisclaimerDialog={handleCloseDisclaimerDialog}
					handleEscapeCloseDisclaimerDialog={handleEscapeCloseDisclaimerDialog}
					emailDisclaimer={emailDisclaimer}
					setEmailDisclaimer={setEmailDisclaimer}
				/>
			</Suspense>
			{/* <Suspense fallback={<div />}>
				<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
			</Suspense> */}
			<Suspense fallback={<div />}>
				{customFormDialogProps ? <LazyCustomFormDialog customFormDialogProps={customFormDialogProps} /> : null}
			</Suspense>
			<div className="kemper-cancer-form plan-form">
				<div className="paper-form-container">
					<Paper className="theme-border-radius paper-container" elevation={1}>
						<VEBPlanHeader
							planName="5Star Term Life Insurance to Age 121"
							effectiveDate={
								planCode
									? planCode === "FP-ALL-2024"
										? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_MMDDYYYY
										: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_MMDDYYYY
									: "N/A"
							}
							planCode={planCode ? (planCode as unknown as string) : "No Plan is Opened"}
						/>
						<div className="plan-content">
							<div className="theme-plan-section-margin" />
							<div className="header-container header-container-new">
								<div className="theme-plan-header">Standard Benefits</div>
							</div>
							<div>
								<div
									className="theme-plan-sub-header plan-text"
									style={{ borderLeftColor: theme.primary_color }}
								>
									In addition to yourself, who would you like to cover under this plan?
								</div>
								<Grid className="grid-container" container columnSpacing={2}>
									<Grid item xl={5} lg={5} md={5} sm={6} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Coverage For</div>
											<Select
												input={<CustomSelectInput />}
												style={{ width: "100%" }}
												name="contact_label"
												onChange={(event: any) => handleCoverageChange(event)}
											>
												{fiveStarPlan.coverage.map((option: string, index: number) => {
													return (
														<MenuItem value={option} key={index}>
															{option}
														</MenuItem>
													);
												})}
											</Select>
										</div>
									</Grid>
									<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Rate Type</div>
											<Select
												input={<CustomSelectInput />}
												style={{ width: "100%" }}
												name="contact_label"
												onChange={(event: any) => handlePlanChange(event)}
											>
												<MenuItem value={"benefit_amount_purchase"}>
													Benefit Amount Purchase
												</MenuItem>
											</Select>
										</div>
									</Grid>
									{/* <Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Benefit Amount</div>
											<Select
												input={<CustomSelectInput />}
												style={{ width: "100%" }}
												name="member_face_amount"
												onChange={(event: any) => handleBenefitAmountChange(event)}
											>
												{fiveStarPlan.coverage_level.map((coverage, index) => {
													return (
														// eslint-disable-next-line react/jsx-key
														<MenuItem value={coverage === null ? "" : coverage}>
															{coverage === null ? "Select" : coverage}
														</MenuItem>
													);
												})}
											</Select>
										</div>
									</Grid>
									<Grid item xl={5} lg={5} md={5} sm={5} xs={6}></Grid>
									<Grid item xl={2} lg={2} md={2} sm={2} xs={6} className="amount-middle">
										<div className="details-form-row">
											<div className="details-form-label required align-center">Premium</div>
											<div className="show-premium">
												{premium_amount == 0 ? "$0.00" : `$${premium_amount.toFixed(2)}`}
											</div>
										</div>
									</Grid> */}
								</Grid>
							</div>
							{eligibleMembers.length > 0 &&
								eligibleMembers.map((member: Member, index: React.Key | null | undefined) => {
									return (
										<div
											key={index}
											className={
												member.relationship &&
												member.relationship === "SPOUSE" &&
												["Employee Only", "Employee & Children"].includes(coverage_for)
													? "disable-child"
													: member.relationship &&
													  ["SON", "CHILD", "DAUGHTER", "STEP CHILD"].includes(
															member?.relationship
													  ) &&
													  ["Employee Only", "Employee & Spouse", "Spouse Only"].includes(
															coverage_for
													  )
													? "disable-child"
													: (member.relationship === null ||
															["SON", "CHILD", "DAUGHTER", "STEP CHILD"].includes(
																member?.relationship
															)) &&
													  ["Spouse Only"].includes(coverage_for)
													? "disable-child"
													: member.relationship === null &&
													  ["Spouse & Children"].includes(coverage_for)
													? "disable-child"
													: coverage_for === ""
													? "disable-child"
													: plan_type === ""
													? "disable-child"
													: ""
											}
										>
											{member.relationship &&
											["SON", "CHILD", "DAUGHTER", "STEP CHILD"].includes(member.relationship) ? (
												<div className="member-name">
													{member.relationship}
													{"("}
													{children.map((child, index) => {
														return (
															<span key={index}>
																{child.first_name} {child.last_name}
																{index + 1 !== children.length ? ", " : ""}
															</span>
														);
													})}{" "}
													{")"}
												</div>
											) : member.relationship !== null ? (
												<div className="member-name">{`${member.relationship}(${member.first_name} ${member.last_name})`}</div>
											) : (
												<div className="member-name">
													{member.first_name} {member.last_name}
													{"(SELF)"}
												</div>
											)}
											<Grid className="grid-container" container columnSpacing={2}>
												<Grid container columnSpacing={2}>
													<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
														<div className="details-form-row">
															<div className="details-form-label  required">
																Benefit Amount
															</div>
															<Select
																input={<CustomSelectInput />}
																style={{ width: "100%" }}
																name={
																	member.role === "EMPLOYEE"
																		? "member_face_amount"
																		: member.relationship === "SPOUSE"
																		? "spouse_face_amount"
																		: "child_face_amount"
																}
																disabled={
																	member.relationship &&
																	member.relationship === "SPOUSE" &&
																	["Employee Only", "Employee & Children"].includes(
																		coverage_for
																	)
																		? true
																		: member.relationship &&
																		  [
																				"SON",
																				"CHILD",
																				"DAUGHTER",
																				"STEP CHILD"
																		  ].includes(member?.relationship) &&
																		  [
																				"Employee Only",
																				"Employee & Spouse",
																				"Spouse Only"
																		  ].includes(coverage_for)
																		? true
																		: (member.relationship === null ||
																				[
																					"SON",
																					"CHILD",
																					"DAUGHTER",
																					"STEP CHILD"
																				].includes(member?.relationship)) &&
																		  ["Spouse Only"].includes(coverage_for)
																		? true
																		: member.relationship === null &&
																		  ["Spouse & Children"].includes(coverage_for)
																		? true
																		: coverage_for === ""
																		? true
																		: plan_type === ""
																		? true
																		: false
																}
																onChange={(event: any) =>
																	handleBenefitAmountChange(event)
																}
															>
																{fiveStarPlan.coverage_level.map((coverage, index) => {
																	if (
																		member.relationship !== null &&
																		["CHILD", "STEP CHILD"].includes(
																			member.relationship
																		) &&
																		(coverage === null ||
																			(coverage !== null && coverage <= 10000))
																	) {
																		return (
																			<MenuItem
																				key={index}
																				value={
																					coverage === null ? "" : coverage
																				}
																			>
																				{coverage === null ? "" : coverage}
																			</MenuItem>
																		);
																	} else if (
																		!["CHILD", "STEP CHILD"].includes(
																			member?.relationship
																				? member?.relationship
																				: ""
																		)
																	) {
																		return (
																			// eslint-disable-next-line react/jsx-key
																			<MenuItem
																				value={
																					coverage === null ||
																					(member.role === "EMPLOYEE" &&
																						[
																							"Spouse & Children",
																							"Spouse Only"
																						].includes(coverage_for)) ||
																					(member.relationship === "SPOUSE" &&
																						[
																							"Employee Only",
																							"Employee & Children"
																						].includes(coverage_for))
																						? // (member?.relationship &&
																						  // 	[
																						  // 		"SON",
																						  // 		"CHILD",
																						  // 		"DAUGHTER",
																						  // 		"STEP CHILD"
																						  // 	].includes(
																						  // 		member?.relationship
																						  // 	) &&
																						  // 	[
																						  // 		"Employee Only",
																						  // 		"Spouse Only",
																						  // 		"Employee & Spouse"
																						  // 	].includes(coverage_for))
																						  ""
																						: coverage
																				}
																			>
																				{coverage === null ||
																				coverage === 5000 ||
																				(member.role === "EMPLOYEE" &&
																					[
																						"Spouse & Children",
																						"Spouse Only"
																					].includes(coverage_for)) ||
																				(member.relationship === "SPOUSE" &&
																					[
																						"Employee Only",
																						"Employee & Children"
																					].includes(coverage_for)) ||
																				(member?.relationship &&
																					[
																						"SON",
																						"CHILD",
																						"DAUGHTER",
																						"STEP CHILD"
																					].includes(member?.relationship) &&
																					[
																						"Employee Only",
																						"Spouse Only",
																						"Employee & Spouse"
																					].includes(coverage_for))
																					? ""
																					: coverage}
																			</MenuItem>
																		);
																	}
																})}
															</Select>
														</div>
													</Grid>
													<Grid item xl={5} lg={5} md={5} sm={5} xs={6}></Grid>
													{member?.relationship == null ? (
														<Grid
															item
															xl={2}
															lg={2}
															md={2}
															sm={2}
															xs={6}
															className="amount-middle"
														>
															<div className="details-form-row">
																<div className="details-form-label required align-center">
																	Premium
																</div>
																<div className="show-premium">
																	{employeeStandardPremiumAmount == 0
																		? "$0.00"
																		: `$${
																				employeeStandardPremiumAmount &&
																				employeeStandardPremiumAmount.toFixed(2)
																		  }`}
																</div>
															</div>
														</Grid>
													) : null}
													{member?.relationship && member?.relationship == "SPOUSE" ? (
														<Grid
															item
															xl={2}
															lg={2}
															md={2}
															sm={2}
															xs={6}
															className="amount-middle"
														>
															<div className="details-form-row">
																<div className="details-form-label required align-center">
																	Premium
																</div>
																<div className="show-premium">
																	{spouseStandardPremiumAmount == 0
																		? "$0.00"
																		: `$${
																				spouseStandardPremiumAmount &&
																				spouseStandardPremiumAmount.toFixed(2)
																		  }`}
																</div>
															</div>
														</Grid>
													) : null}
													{member?.relationship &&
													["SON", "CHILD", "DAUGHTER", "STEP CHILD"].includes(
														member?.relationship
													) ? (
														<Grid
															item
															xl={2}
															lg={2}
															md={2}
															sm={2}
															xs={6}
															className="amount-middle"
														>
															<div className="details-form-row">
																<div className="details-form-label required align-center">
																	Premium
																</div>
																<div className="show-premium">
																	{childStandardPremiumAmount == 0
																		? "$0.00"
																		: `$${
																				childStandardPremiumAmount &&
																				childStandardPremiumAmount.toFixed(2)
																		  }`}
																</div>
															</div>
														</Grid>
													) : null}
												</Grid>
											</Grid>
										</div>
									);
								})}
						</div>
						<div className="theme-plan-inner-section-margin" />
						<Grid container className="theme-plan-inner-section-margin">
							<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
								<div className="details-form-row">
									<div
										className="details-form-label theme-plan-total-premium align-right"
										style={{ color: theme.primary_color }}
									>
										Total Premium:
										<span className="show-premium margin-adjust">
											{totalPremiumAmount === 0 ? "$0.00" : `$${totalPremiumAmount.toFixed(2)}`}
										</span>
									</div>
								</div>
							</Grid>
						</Grid>

						<div className="accordion-container">
							<Accordion
								expanded={expanded === "panel_question"}
								className="accordion-ques"
								onChange={handleChange("panel_question")}
							>
								<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
									<Typography>Questions</Typography>
								</AccordionSummary>
								{maxBenefitMember && maxBenefitMember.length > 0 ? (
									questions.map((question, firstIndex) => {
										return (
											<AccordionDetails key={firstIndex}>
												<Typography>
													<b>Q{firstIndex + 1}</b> {question.question}
													<div>
														<b>Set all answer to</b>
														<input
															type="radio"
															id={`yes-${firstIndex + 1}-all`}
															name={`Q-${firstIndex + 1}-all`}
															value="yes"
															onChange={(event: any) => handleAnswerChange(event)}
															checked={false}
														/>
														<label htmlFor={`yes-${firstIndex + 1}-all`}>Yes</label>
														<input
															type="radio"
															id={`no-yes-${firstIndex + 1}-all`}
															name={`Q-${firstIndex + 1}-all`}
															value="no"
															onChange={(event: any) => handleAnswerChange(event)}
															checked={
																allAnswerRecord.some(
																	(answer: string) =>
																		Number(answer) === firstIndex + 1
																)
																	? true
																	: false
															}
														/>
														<label htmlFor={`no-${firstIndex + 1}-all`}>No</label>
													</div>
													<div className="radio-container">
														{maxBenefitMember.map(
															(currentMember: Member, index: number) => {
																return (
																	<div className="radio-item" key={index}>
																		<b>
																			{currentMember.first_name}{" "}
																			{currentMember.last_name}
																		</b>
																		<input
																			type="radio"
																			id={`yes-${firstIndex + 1}-${
																				currentMember.SSN
																			}`}
																			name={`Q-${firstIndex + 1}-${
																				currentMember.SSN
																			}`}
																			value="yes"
																			onChange={(event: any) =>
																				handleAnswerChange(event)
																			}
																			checked={false}
																		/>
																		<label
																			htmlFor={`yes-${firstIndex + 1}-${
																				currentMember.SSN
																			}`}
																		>
																			Yes
																		</label>
																		<input
																			type="radio"
																			id={`no-${firstIndex + 1}-${
																				currentMember.SSN
																			}`}
																			name={`Q-${firstIndex + 1}-${
																				currentMember.SSN
																			}`}
																			value="no"
																			onChange={(event: any) =>
																				handleAnswerChange(event)
																			}
																			checked={
																				answerList.length > 0 &&
																				answerList.some(
																					(answer: AnswerData) =>
																						Number(answer.questionNo) ===
																							firstIndex + 1 &&
																						answer?.SSN ===
																							currentMember.SSN &&
																						answer?.answer === "no"
																				)
																					? true
																					: false
																			}
																		/>
																		<label
																			htmlFor={`no-${firstIndex + 1}-${
																				currentMember.SSN
																			}`}
																		>
																			No
																		</label>
																	</div>
																);
															}
														)}
													</div>
												</Typography>
											</AccordionDetails>
										);
									})
								) : (
									<AccordionDetails>
										<Typography>
											No eligibility questions are required for the selected coverage, please
											press next.
										</Typography>
									</AccordionDetails>
								)}
							</Accordion>
						</div>
						<div className="accordion-container">
							<Accordion
								expanded={expanded_panel === "panel_beneficiary"}
								onChange={handleBeneficiaryChange("panel_beneficiary")}
							>
								<AccordionSummary aria-controls="panel1d-content" id="panel-header-beneficiary">
									<Typography>Add Beneficiary</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<Grid
										container
										justifyContent={"center"}
										justifyItems="center"
										alignItems={"center"}
									>
										{member &&
										(coverage_for === "Employee Only" ||
											coverage_for === "Employee & Children" ||
											coverage_for === "Employee & Spouse" ||
											coverage_for === "Employee & Family") ? (
											<Grid item xl={12} lg={12} md={12}>
												<VEBBeneficiary
													primaryBeneficiary={BV2employeePrimaryBeneficiary}
													setPrimaryBeneficiary={setBV2EmployeePrimaryBeneficiary}
													contingentBeneficiary={BV2employeeContingentBeneficiary}
													setContingentBeneficiary={setBV2EmployeeContingentBeneficiary}
													member={member}
													employee={member}
													dependents={dependents}
												/>
											</Grid>
										) : null}
										{spouse &&
										(coverage_for === "Employee & Spouse" ||
											coverage_for === "Spouse Only" ||
											coverage_for === "Spouse & Children" ||
											coverage_for === "Employee & Family") ? (
											<Grid item xl={12} lg={12} md={12}>
												<div className="theme-plan-section-margin" />
												<VEBBeneficiary
													primaryBeneficiary={BV2spousePrimaryBeneficiary}
													setPrimaryBeneficiary={setBV2SpousePrimaryBeneficiary}
													contingentBeneficiary={BV2spouseContingentBeneficiary}
													setContingentBeneficiary={setBV2SpouseContingentBeneficiary}
													member={spouse}
													employee={member}
													dependents={dependents}
												/>
											</Grid>
										) : null}
										{coverage_for === "Employee & Children" ||
										coverage_for === "Spouse & Children" ||
										coverage_for === "Employee & Family" ? (
											<Grid item xl={12} lg={12} md={12}>
												<div className="theme-plan-section-margin" />
												<VEBBeneficiary
													primaryBeneficiary={BV2childPrimaryBeneficiary}
													setPrimaryBeneficiary={setBV2ChildPrimaryBeneficiary}
													contingentBeneficiary={BV2childContingentBeneficiary}
													setContingentBeneficiary={setBV2ChildContingentBeneficiary}
													isChild
													member={member}
													employee={member}
													dependents={dependents}
												/>
											</Grid>
										) : null}
									</Grid>
								</AccordionDetails>
								{/* <AccordionDetails>
									<Grid container className="card-grid-container">
										{coverage_for === "Employee Only" &&
										plan_type !== "" &&
										employeeBenefitAmount !== 0 ? (
											<Grid item xl={5} lg={5} md={5} sm={5} xs={10} columnSpacing={2}>
												<VEBPlanCard
													handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
													cardId="member-card"
													addBeneficiaryDetails={[
														...addMemberPrimaryBeneficiary,
														...addMemberContigentBeneficiary
													]}
													memberName={member.first_name}
													primaryBeneficiaryCount={primaryMemberBeneficiary.count}
													contingentBeneficiaryCount={contingentMemberBeneficiary.count}
													primaryBeneficiaryPercentage={primaryMemberBeneficiary.percentage}
													contingentBeneficiaryPercentage={
														contingentMemberBeneficiary.percentage
													}
													handleEdit={handleEdit}
													handleDelete={handleDelete}
												></VEBPlanCard>
											</Grid>
										) : coverage_for === "Employee & Spouse" &&
										  plan_type !== "" &&
										  employeeBenefitAmount !== 0 ? (
											<>
												<Grid item xl={5} lg={5} md={5} sm={5} xs={10} columnSpacing={2}>
													<VEBPlanCard
														handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
														cardId="member-card"
														addBeneficiaryDetails={[
															...addMemberPrimaryBeneficiary,
															...addMemberContigentBeneficiary
														]}
														memberName={member.first_name}
														primaryBeneficiaryCount={primaryMemberBeneficiary.count}
														contingentBeneficiaryCount={contingentMemberBeneficiary.count}
														primaryBeneficiaryPercentage={
															primaryMemberBeneficiary.percentage
														}
														contingentBeneficiaryPercentage={
															contingentMemberBeneficiary.percentage
														}
														handleEdit={handleEdit}
														handleDelete={handleDelete}
													></VEBPlanCard>
												</Grid>
												<Grid item xl={5} lg={5} md={5} sm={5} xs={10} columnSpacing={2}>
													<VEBPlanCard
														handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
														cardId="spouse-card"
														addBeneficiaryDetails={[
															...addSpousePrimaryBeneficiary,
															...addSpouseContigentBeneficiary
														]}
														memberName={spouse?.first_name}
														primaryBeneficiaryCount={primarySpouseBeneficiary.count}
														contingentBeneficiaryCount={contingentSpouseBeneficiary.count}
														primaryBeneficiaryPercentage={
															primarySpouseBeneficiary.percentage
														}
														contingentBeneficiaryPercentage={
															contingentSpouseBeneficiary.percentage
														}
														handleEdit={handleEdit}
														handleDelete={handleDelete}
													></VEBPlanCard>
												</Grid>
											</>
										) : coverage_for === "Employee & Children" &&
										  plan_type !== "" &&
										  employeeBenefitAmount !== 0 ? (
											<>
												<Grid item xl={5} lg={5} md={5} sm={5} xs={10} columnSpacing={2}>
													<VEBPlanCard
														handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
														cardId="member-card"
														addBeneficiaryDetails={[
															...addMemberPrimaryBeneficiary,
															...addMemberContigentBeneficiary
														]}
														memberName={member.first_name}
														primaryBeneficiaryCount={primaryMemberBeneficiary.count}
														contingentBeneficiaryCount={contingentMemberBeneficiary.count}
														primaryBeneficiaryPercentage={
															primaryMemberBeneficiary.percentage
														}
														contingentBeneficiaryPercentage={
															contingentMemberBeneficiary.percentage
														}
														handleEdit={handleEdit}
														handleDelete={handleDelete}
													></VEBPlanCard>
												</Grid>
												{dependents
													.filter(
														(dependentMember: Member, index: number) =>
															dependentMember.relationship !== "SPOUSE"
													)
													.map((dependentFilterMember: Member, index: number) => {
														return (
															<>
																<Grid
																	item
																	xl={5}
																	lg={5}
																	md={5}
																	sm={5}
																	xs={10}
																	columnSpacing={2}
																>
																	<VEBPlanCard
																		handleAddBeneficiaryDetails={
																			handleAddBeneficiaryDetails
																		}
																		plan_code={familyProtectionPlan.plan_code}
																		cardId="children-card"
																		addBeneficiaryDetails={[
																			...addMemberPrimaryBeneficiary
																		]}
																		memberName={dependentFilterMember.first_name}
																		primaryBeneficiaryCount={
																			primaryMemberBeneficiary.count
																		}
																		contingentBeneficiaryCount={
																			contingentMemberBeneficiary.count
																		}
																		primaryBeneficiaryPercentage={
																			primaryMemberBeneficiary.percentage
																		}
																		contingentBeneficiaryPercentage={
																			contingentMemberBeneficiary.percentage
																		}
																		handleEdit={handleEdit}
																		handleDelete={handleDelete}
																	></VEBPlanCard>
																</Grid>
															</>
														);
													})}{" "}
											</>
										) : null}
									</Grid>
								</AccordionDetails> */}
							</Accordion>
						</div>
						{!VEBPlanCodes2024.includes(planCode as unknown as string) ? (
							<div className="veb-disclaimer">{/* <VEBDisclaimer /> */}</div>
						) : null}
						<div className="theme-plan-option-content">
							<Checkbox
								checked={isActivelyWorking}
								style={{ paddingLeft: 0 }}
								onChange={handleIsActivelyWorkingCheckboxChange}
							/>
							<p className="theme-plan-checkbox-label">
								<strong>Are you actively at work 20 or more hours per week?</strong>
							</p>
						</div>
						<div>
							<div className="theme-plan-option-content">
								<Checkbox
									checked={hasReadTC}
									style={{ paddingLeft: 0 }}
									onChange={handleAgreedTCCheckboxChange}
								/>
								<p className="theme-plan-checkbox-label">
									<strong>
										I have read the{" "}
										<span
											className="veb-plan-disclaimer"
											style={{ color: theme.primary_color }}
											onClick={handleOpenDisclaimerDialogClick}
										>
											Disclaimer
										</span>
									</strong>
								</p>
							</div>
						</div>
						{/* <div className="theme-plan-inner-section-margin-2" />
						<Grid container>
							<Grid item xl={4} lg={4} md={4} sm={4} xs={10} columnSpacing={2}>
								<div className="details-form-row">
									<div className="details-form-label required">Writing Number</div>
									<Grid container>
										<Grid item xl={9}>
											<CustomInput value={writingNumber} onChange={handleWritingNumberChange} />
										</Grid>
										{showWritingNumberValidateButton ? (
											<Grid item xl={3}>
												<div className="writing-number-validate-container">
													<Button
														style={{
															backgroundColor: theme.button.background_color,
															color: theme.button.color,
															opacity: 0.8
														}}
													>
														Validate
													</Button>
												</div>
											</Grid>
										) : null}
									</Grid>
								</div>
							</Grid>
						</Grid> */}
						<div className="theme-plan-inner-section-margin-2" />
						<LazyPlanActions
							waiveButtonCallback={handleWaiveButtonClick}
							activateButtonCallback={handleActivateButtonClick}
						/>
					</Paper>
				</div>
			</div>
			<VEBModal
				open={modalOpen}
				familyDetails={
					selectCard === "member-card"
						? [member, ...dependents].filter((mem: Member, index: number) => {
								return ![...addMemberPrimaryBeneficiary, ...addMemberContigentBeneficiary].some(
									(val: any, index: number) => val.enrollment_id === mem._id
								);
						  })
						: [member, ...dependents].filter((mem: Member, index: number) => {
								return ![...addSpousePrimaryBeneficiary, ...addSpouseContigentBeneficiary].some(
									(val: any, index: number) => val.enrollment_id === mem._id
								);
						  })
				}
				data={editData}
				handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
				handleClose={handleClose}
			></VEBModal>
		</Suspense>
	);
};

export default FiveStarFamilyProtectionForm;
